import { createFileRoute } from '@tanstack/react-router';
import { AuditLogPage } from '@pages/audit-log';

/** Protokoll-Route (/audit-log) */
export const Route = createFileRoute('/_authenticated/audit-log')({
  component: AuditLogPage,
});
